<template>
  <div class="content">
    <form class="form-horizontal" @submit.prevent="onSubmit">
      <card class="text-left">
        <template slot="header">
          <h4 class="card-title">아티스트 상세</h4>
        </template>
        <div class="row">
          <label class="col-sm-2 col-form-label">대표 이미지</label>
          <div class="col-sm-4">
            <BlipFileUploadZone :upload-category="4" :maxFiles="1" :fileUrl="imageFileUrl" @onChangeFileIds="onFileIdChange" />
          </div>
          <label class="col-sm-2 col-form-label">로고 이미지</label>
          <div class="col-sm-4">
            <BlipFileUploadZone :upload-category="4" :maxFiles="1" :fileUrl="logoFileUrl" @onChangeFileIds="onLogoFileIdChange" />
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">등록일</label>
          <div class="col-sm-4">
            <base-input placeholder="" v-model="regDate" disabled>
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          <label class="col-sm-2 col-form-label">오픈일</label>
          <div class="col-sm-4">
            <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="오픈일" v-model="openDate"></el-date-picker>
          </div>
          <label class="col-sm-2 col-form-label">팔로워수</label>
          <div class="col-sm-4">
            <base-input placeholder="" v-model="followCount" disabled>
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          <label class="col-sm-2 col-form-label">홈페이지경로</label>
          <div class="col-sm-4">
            <base-input placeholder="경로" v-model="path">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">아티스트명</label>
          <div class="col-sm-4">
            <base-input placeholder="성" v-model="name" disabled>
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          <label class="col-sm-2 col-form-label">블립아티스트명</label>
          <div class="col-sm-4">
            <base-input placeholder="블립아티스트명" v-model="blipName">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
        </div>

        <div class="row">
          <label class="col-sm-2 col-form-label">노출여부</label>
          <div class="col-sm-4">
            <base-switch v-model="isVisible" type="primary" on-text="ON" off-text="OFF" />
          </div>
          <label class="col-sm-2 col-form-label">그룹</label>
          <div class="col-sm-4">
            <base-switch v-model="isGroup" type="primary" on-text="ON" off-text="OFF" />
          </div>
          <label class="col-sm-2 col-form-label">NEW 배지</label>
          <div class="col-sm-4">
            <base-switch v-model="isNew" type="primary" on-text="ON" off-text="OFF" />
          </div>
          <label class="col-sm-2 col-form-label">NEXT 배지</label>
          <div class="col-sm-4">
            <base-switch v-model="isNext" type="primary" on-text="ON" off-text="OFF" />
          </div>
          <label class="col-sm-2 col-form-label">아티스트구분</label>
          <div class="col-sm-4">
            <base-radio name="boy" inline v-model="artistType">보이그룹</base-radio>
            <base-radio name="girl" inline v-model="artistType">걸그룹</base-radio>
            <base-radio name="solo" inline v-model="artistType">솔로</base-radio>
            <base-radio name="mix" inline v-model="artistType">혼성</base-radio>
          </div>
          <label class="col-sm-2 col-form-label">필터 여부</label>
          <div class="col-sm-4">
            <base-switch v-model="isFilter" type="primary" on-text="ON" off-text="OFF" />
          </div>
          <label class="col-sm-2 col-form-label">무료개방</label>
          <div class="col-sm-8">
            <el-date-picker type="datetimerange" start-placeholder="시작일" end-placeholder="종료일" v-model="freePeriod" />
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">서포트 자동생성</label>
          <div class="col-sm-8">
            <base-switch :value="isFundingAuto" @input="onFundingAutoToggle" type="primary" on-text="ON" off-text="OFF" />
            <span class="form-text text-muted">축하 스케줄 등록 시 서포트 투표가 자동 생성됩니다. (변경 즉시 저장)</span>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label"></label>
          <base-button @click="loadMembers" type="success">멤버불러오기</base-button>
          <label class="col-sm-2 col-form-label"></label>
          <base-button @click="goArtistNameForm" type="success">이름 설정</base-button>
          <label class="col-sm-2 col-form-label"></label>
          <base-button @click="setArtistOrder" type="default">노출순서변경</base-button>
          <label class="col-sm-2 col-form-label"></label>
          <base-button @click="refreshContentCounts" :loading="isRefreshingContentCounts" :disabled="isRefreshingContentCounts" type="info">
            트렌드 카운트 갱신
          </base-button>
          <!--          <label class="col-sm-2 col-form-label"></label>-->
          <!--          <base-button @click="unfollowUsers" type="danger">팔로워날리기</base-button>-->
        </div>
        <el-popover trigger="hover" placement="top">
          <div>
            <div class="popover-body">드래그앤드랍으로 노출순서를 변경할 수 있습니다</div>
          </div>
          <base-button slot="reference"> ? </base-button>
        </el-popover>
        <!--        <draggable class="row" v-model="members" group="people" @start="drag = true" @end="drag = false">-->
        <!--          <div v-for="(item, index) in members">{{ item.name }}</div>-->
        <!--        </draggable>-->
        <div class="row">
          <div class="col-sm-2 text-center">멤버이름</div>
          <div class="col-sm-2 text-center">블립대표명</div>
          <div class="col-sm-2 text-center">노출여부</div>
          <div class="col-sm-2 text-center">이름설정</div>
          <div class="col-sm-2 text-center">이미지</div>
        </div>
        <div class="row">
          <hr />
        </div>
        <div class="row">
          <div class="col-sm-12">
            <draggable class="row" v-model="members" group="people" @start="drag = true" @end="drag = false">
              <div class="col-sm-12" v-for="member in members" :key="member.artistId">
                <div class="row">
                  <div class="col-sm-2 text-center">
                    {{ member.name }}
                  </div>
                  <div class="col-sm-2 text-center">
                    <div>
                      <base-input v-model="member.blipName" />
                    </div>
                  </div>
                  <div class="col-sm-2 text-center">
                    <div>
                      <base-switch v-model="member.isVisible" type="primary" on-text="ON" off-text="OFF" />
                    </div>
                  </div>
                  <div class="col-sm-2 text-center">
                    <div>
                      <base-button @click="goArtistMemberNameForm(member.artistId, member.name)" type="success">이름 설정</base-button>
                    </div>
                  </div>
                  <div class="col-sm-2 text-center">
                    <div>
                      <BlipFileUploadZone
                        :upload-category="4"
                        :maxFiles="1"
                        :fileUrl="member.imageFileUrl"
                        @onChangeFileIds="onMemberFileIdChange($event, member)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </draggable>
          </div>

          <!--          <el-table :data="members">-->
          <!--            <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth" :prop="column.prop" :label="column.label" />-->
          <!--            <el-table-column :min-width="80" align="center" label="블립대표명">-->
          <!--              <div slot-scope="props">-->
          <!--                <base-input v-model="props.row.blipName" />-->
          <!--              </div>-->
          <!--            </el-table-column>-->
          <!--            <el-table-column :min-width="80" align="center" label="노출여부">-->
          <!--              <div slot-scope="props">-->
          <!--                <base-switch v-model="props.row.isVisible" type="primary" on-text="ON" off-text="OFF" />-->
          <!--              </div>-->
          <!--            </el-table-column>-->
          <!--            <el-table-column :min-width="80" align="center" label="이름설정">-->
          <!--              <div slot-scope="props">-->
          <!--                <base-button @click="goArtistMemberNameForm(props.row.artistId, props.row.name)" type="success">이름 설정</base-button>-->
          <!--              </div>-->
          <!--            </el-table-column>-->
          <!--            <el-table-column :min-width="80" align="center" label="이미지">-->
          <!--              <div slot-scope="props">-->
          <!--                <BlipFileUploadZone-->
          <!--                  :upload-category="4"-->
          <!--                  :maxFiles="1"-->
          <!--                  :fileUrl="props.row.imageFileUrl"-->
          <!--                  @onChangeFileIds="onMemberFileIdChange($event, props.row)"-->
          <!--                />-->
          <!--              </div>-->
          <!--              &lt;!&ndash;              v-on:input="addToCart($event, ticket.id)"&ndash;&gt;-->
          <!--            </el-table-column>-->
          <!--            &lt;!&ndash;            <el-table-column :min-width="50" align="right" label="삭제">&ndash;&gt;-->
          <!--            &lt;!&ndash;              <div slot-scope="props">&ndash;&gt;-->
          <!--            &lt;!&ndash;                <base-button @click.native="handleDelete(props.row.artistId)" class="edit btn-link" type="warning" size="sm" icon>&ndash;&gt;-->
          <!--            &lt;!&ndash;                  <i class="tim-icons icon-simple-delete" />&ndash;&gt;-->
          <!--            &lt;!&ndash;                </base-button>&ndash;&gt;-->
          <!--            &lt;!&ndash;              </div>&ndash;&gt;-->
          <!--            &lt;!&ndash;            </el-table-column>&ndash;&gt;-->
          <!--          </el-table>-->
        </div>
      </card>
      <base-button native-type="submit" type="success">등록</base-button>
      <base-button @click="goBack" type="default">취소</base-button>
    </form>
  </div>
</template>
<script>
import { Alert } from "@/util/Alert";
import BlipFileUploadZone from "@/components/BlipFileUploadZone";
import { Card, BaseInput, BaseSwitch } from "@/components/index";
import { BlipFileUploader } from "@/util/BlipFileUploader";
import * as _ from "lodash";
import swal from "sweetalert2";
import draggable from "vuedraggable";

export default {
  components: {
    Card,
    BaseInput,
    BlipFileUploadZone,
    BaseSwitch,
    draggable,
  },
  async created() {
    if (!this.$route.query.unitId) {
      window.Toast.error("잘못된접근입니다");
      history.go(-1);
      return;
    }

    this.unitId = this.$route.query.unitId;
    await this.getData();
  },
  data() {
    return {
      unitId: null,
      artistId: null,
      blipName: null,
      name: null,
      imageFileId: null,
      logoFileId: null,
      imageFileUrl: null,
      logoFileUrl: null,
      regDate: null,
      openDate: null,
      followCount: null,
      members: [],
      isGroup: true,
      isNew: false,
      isNext: false,
      isFilter: false,
      freePeriod: null,
      artistType: "boy",
      isVisible: false,
      isFundingAuto: false,
      path: null,
      isRefreshingContentCounts: false,
    };
  },
  computed: {
    contentCountArtistName() {
      return this.blipName || this.name || "선택한 아티스트";
    },
  },
  watch: {
    isVisible() {
      if (this.isVisible) {
        this.isNext = false;
      }
    },
    isNew() {
      if (this.isNew) {
        this.isNext = false;
      }
    },
    isNext() {
      if (this.isNext) {
        this.isVisible = false;
        this.isNew = false;
        window.Toast.info("NEXT 배지가 ON이면 노출여부를 OFF로 설정해야 합니다");
      }
    },
  },
  methods: {
    onFileIdChange(newFileIds) {
      this.imageFileId = newFileIds[0];
    },
    onLogoFileIdChange(newFileIds) {
      this.logoFileId = newFileIds[0];
    },
    onMemberFileIdChange(newFileIds, member) {
      for (let i = 0; i < this.members.length; i++) {
        if (this.members[i].artistId === member.artistId) {
          this.members[i].imageFileId = newFileIds[0];
        }
      }
    },

    async getData() {
      return this.$axios.get(`/artistUnit/${this.unitId}`).then((res) => {
        const data = res.data.data;
        if (data) {
          this.unitId = data.unitId;
          this.artistId = data.artistId;
          this.name = data.name;
          this.blipName = data.blipName;
          this.imageFileId = data.imageFileId;
          this.logoFileId = data.logoFileId;
          this.followCount = data.followCount;
          this.regDate = data.regDate;
          this.isGroup = data.isGroup === 1;
          this.isNew = data.isNew === 1;
          this.isNext = data.isNext === 1;
          this.isFilter = data.isFilter === 1;
          this.isVisible = data.isVisible === 1;
          this.isFundingAuto = data.isFundingAuto === 1;
          this.path = data.path;
          try {
            const backgroundInfo = JSON.parse(data.backgroundInfo);
            this.artistType = backgroundInfo.artistType;
            this.openDate = backgroundInfo.openDate;
            this.freePeriod = [backgroundInfo.freeStartTime, backgroundInfo.freeEndTime];
          } catch (e) {
            _.noop(e);
          }
          if (this.imageFileId) {
            this.imageFileUrl = window.Endpoints.imageServerUrl + this.imageFileId;
          }
          if (this.logoFileId) {
            this.logoFileUrl = window.Endpoints.imageServerUrl + this.logoFileId;
          }
          this.members = data.members;
          for (let i = 0; i < this.members.length; i++) {
            this.members[i].isVisible = this.members[i].isVisible === 1;
            if (this.members[i].imageFileId) {
              this.members[i].imageFileUrl = window.Endpoints.imageServerUrl + this.members[i].imageFileId;
            }
          }
        }
      });
    },
    setFlag(flag) {
      if (flag === "next") {
        if (this.isNext) {
          this.isVisible = false;
          this.isNew = false;
        }
      } else if (flag === "new" || flag === "visible") {
        if (this.isNew || this.isVisible) {
          this.isNext = false;
        }
      }
    },
    async loadMembers() {
      return this.$axios.get(`/artistUnit/${this.artistId}/allMembers`).then((res) => {
        const data = res.data.data.map((item) => {
          return { artistId: item.id, name: item.name };
        });
        const currentMembers = this.members.map((item) => {
          return { artistId: item.artistId, name: item.name };
        });
        const newMembers = _.differenceWith(data, currentMembers, _.isEqual);
        if (newMembers.length === 0) {
          window.Toast.error("추가할 멤버가 없습니다");
          return;
        }

        const members = newMembers.map((item) => {
          item.blipName = item.name;
          item.fileId = null;
          item.fileId = null;
          item.imageFileUrl = null;
          item.isVisible = null;
          return item;
        });
        this.members = this.members.concat(members);
      });
    },

    async unfollowUsers() {
      if (await Alert.dangerousConfirmCancel("언팔로우", "해당 아티스트의 팔로우가 모두 해제됩니다.\n 계속하시겠습니까?", "네", "아니오")) {
        try {
          await this.$axios.delete(`/artistUnit/${this.unitId}/users`);
          window.Toast.success(`언팔로우 되었습니다`);
        } catch (err) {
          window.Toast.error("언팔로우 중 에러가 발생하였습니다.");
        }
      }
    },
    async refreshContentCounts() {
      if (this.isRefreshingContentCounts) {
        return;
      }

      this.isRefreshingContentCounts = true;
      try {
        const confirmed = await swal.fire({
          title: "트렌드 카운트 갱신 확인",
          text: `${this.contentCountArtistName}의 일별/월별 콘텐츠 카운트를 갱신하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-info btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "갱신",
          cancelButtonText: "취소",
          buttonsStyling: false,
        });

        if (!confirmed.value) {
          return;
        }

        const res = await this.$axios.put(`/radarContent/units/${this.unitId}/contentCounts`);
        const result = res.data.data;
        window.Toast.success("트렌드 카운트가 갱신되었습니다");
        await swal.fire({
          title: "갱신 완료",
          html: this.makeContentCountResultMessage(result),
          type: "success",
          confirmButtonText: "확인",
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-info btn-fill",
          },
        });
      } catch (err) {
        window.Toast.error(err.response?.data?.error?.message ?? "트렌드 카운트 갱신 중 에러가 발생하였습니다");
      } finally {
        this.isRefreshingContentCounts = false;
      }
    },
    makeContentCountResultMessage(result) {
      const daily = this.formatContentCountRows(result.daily);
      const monthly = this.formatContentCountRows(result.monthly);
      const artistName = result.unitName || this.contentCountArtistName;
      return `
        <div class="text-left">
          <div><b>${artistName}</b></div>
          <div class="mt-3"><b>일별</b><br>${daily}</div>
          <div class="mt-3"><b>월별</b><br>${monthly}</div>
        </div>
      `;
    },
    formatContentCountRows(rows) {
      if (!rows || rows.length === 0) {
        return "갱신 대상 없음";
      }
      return rows.map((row) => `${row.date}: ${row.count}`).join("<br>");
    },

    async onUploadSuccess(file) {
      const uploader = new BlipFileUploader();
      await uploader.markFileAsUploaded(this.uploadMetaLookup[file.upload.uuid].fileId);
    },
    async onAddFiles() {
      this.uploadMeta = [];
      this.uploadMetaLookup = {};
    },
    handleDelete(artistId) {
      for (let i = 0; i < this.members.length; i++) {
        if (this.members[i].artistId === artistId) {
          this.members.splice(i, 1);
          break;
        }
      }
    },

    async onSubmit() {
      if (!this.unitId) {
        window.Toast.error("잘못된 접근입니다.");
        return;
      }

      const backgroundInfo = this.freePeriod
        ? {
            isNew: this.isNew ? 1 : 0,
            artistType: this.artistType,
            openDate: this.openDate,
            freeStartTime: this.freePeriod[0],
            freeEndTime: this.freePeriod[1],
          }
        : { isNew: this.isNew ? 1 : 0, artistType: this.artistType, openDate: this.openDate };
      const param = {
        imageFileId: this.imageFileId,
        logoFileId: this.logoFileId,
        blipName: this.blipName,
        isGroup: this.isGroup ? 1 : 0,
        isNew: this.isNew ? 1 : 0,
        isNext: this.isNext ? 1 : 0,
        isFilter: this.isFilter ? 1 : 0,
        isVisible: this.isVisible ? 1 : 0,
        path: this.path,
        backgroundInfo: JSON.stringify(backgroundInfo),
      };
      const members = this.members;
      for (let i = 0; i < members.length; i++) {
        members[i].isVisible = members[i].isVisible ? 1 : 0;
        if (!members[i].imageFileId) {
          members[i].imageFileId = null;
        }
      }
      param.members = members;
      return this.$axios
        .put(`/artistUnit/${this.unitId}`, {
          params: param,
        })
        .then(() => {
          window.Toast.success("등록되었습니다");
          this.getData();
        });
    },
    async setArtistOrder() {
      const members = [];
      this.members.forEach((member, order) => {
        members.push({ memberId: member.artistId, order });
      });
      return this.$axios.put(`/artistUnit/${this.unitId}/order`, { members }).then(() => {
        window.Toast.success("아티스트 노출순서가 변경되었습니다");
      });
    },
    async onFundingAutoToggle(next) {
      const prev = this.isFundingAuto;
      this.isFundingAuto = next;
      try {
        await this.$axios.put(`/artistUnit/${this.unitId}/funding-auto`, {
          params: { isFundingAuto: next },
        });
        window.Toast.success(next ? "서포트 자동생성이 켜졌습니다" : "서포트 자동생성이 꺼졌습니다");
      } catch (err) {
        this.isFundingAuto = prev;
        window.Toast.error(err.response?.data?.error?.message ?? "서포트 자동생성 설정 중 에러가 발생하였습니다");
      }
    },
    goArtistNameForm() {
      this.$router.push(`/blipArtist/blipArtistNames?unitId=${this.unitId}&blipName=${this.blipName}`);
    },
    goArtistMemberNameForm(memberId, name) {
      this.$router.push(`/blipArtist/blipArtistMemberNames?unitId=${this.unitId}&memberId=${memberId}&blipName=${name}`);
    },
    goBack() {
      history.go(-1);
    },
  },
};
</script>
<style>
.bootstrap-switch {
  margin: 6px;
}
</style>
